import styled from 'styled-components';

import { purple1, purple7 } from 'approot/shared/styles/colours.style';
import { SnackbarNotificationStyled } from 'approot/shared/snackbar-notification/snackbar-notification.style';
import { spacing24 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';

export const InteractiveResponseSnackbar = styled(SnackbarNotificationStyled)`
  display: block;
  bottom: ${rem(spacing24)};
  background-color: ${purple1};
  color: ${purple7};
`;
